import React, { useState } from 'react';
import {
  AppBar, Toolbar, IconButton, Typography, Drawer, List, ListItem,
  ListItemButton, ListItemText, Box, Divider, Chip
} from '@mui/material';
import MenuIcon from '@mui/icons-material/Menu';
import LogoutIcon from '@mui/icons-material/Logout';

const menuItems = [
  { key: 'home', label: 'Início' },
  { key: 'OrcamentoDetalhado', label: 'Controle Detalhado de Orçamento' },
  { key: 'convidados', label: 'Convidados' },
  { key: 'fotografo', label: 'Fotógrafo' },
  { key: 'comida', label: 'Comida' },
  { key: 'decoracao', label: 'Decoração' },
  { key: 'lembrancinha', label: 'Lembrancinha' },
  { key: 'caixas_convite', label: 'Convite padrinhos' },
  { key: 'cerimonialista', label: 'Cerimonialista' },
  { key: 'cha_panela', label: 'Chá de Panela' },
  { key: 'vestido_noiva', label: 'Vestido da Noiva' },
  { key: 'cha_panela_desejos', label: 'Chá de Panela - Desejos' },
  { key: 'espaco_recepcao', label: 'Espaço Recepção' },
  { key: 'daminha_pajem', label: 'Daminha/Pajem' },
  { key: 'curso_noivos', label: 'Curso de Noivos' },
  { key: 'igreja', label: 'Igreja' },
  { key: 'making_of_noiva', label: 'Making of da Noiva' },
];

function Menu({ setPage, usuario, perfil, onLogout }) {
  const [open, setOpen] = useState(false);
  const isAdmin = perfil === 'admin';

  const visibleMenuItems = isAdmin
    ? menuItems
    : menuItems.filter(item => ['home', 'convidados'].includes(item.key));

  const allItems = isAdmin
    ? [...visibleMenuItems, { key: 'admin_usuarios', label: 'Gestão de Usuários' }]
    : visibleMenuItems;

  return (
    <AppBar position="static" sx={{ bgcolor: '#A0522D' }}>
      <Toolbar>
        <Typography variant="h5" sx={{ flexGrow: 1, fontFamily: 'Great Vibes, cursive', letterSpacing: 2 }}>
          Casamento Graziele & Fernando
        </Typography>
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mr: 1 }}>
          <Typography variant="body2" sx={{ display: { xs: 'none', sm: 'block' } }}>
            {usuario}
          </Typography>
          {isAdmin && <Chip label="Admin" size="small" color="secondary" />}
          <IconButton color="inherit" onClick={onLogout} title="Sair">
            <LogoutIcon />
          </IconButton>
        </Box>
        <IconButton color="inherit" edge="end" onClick={() => setOpen(true)}>
          <MenuIcon />
        </IconButton>
        <Drawer anchor="right" open={open} onClose={() => setOpen(false)}>
          <Box sx={{ width: 280 }}>
            <Box sx={{ p: 2 }}>
              <Typography variant="subtitle1">{usuario}</Typography>
              <Chip
                label={isAdmin ? 'Administrador' : 'Usuário'}
                size="small"
                color={isAdmin ? 'primary' : 'default'}
                sx={{ mt: 0.5 }}
              />
            </Box>
            <Divider />
            <List>
              {allItems.map(item => (
                <ListItem key={item.key} disablePadding>
                  <ListItemButton onClick={() => { setPage(item.key); setOpen(false); }}>
                    <ListItemText primary={item.label} />
                  </ListItemButton>
                </ListItem>
              ))}
              <Divider sx={{ my: 1 }} />
              <ListItem disablePadding>
                <ListItemButton onClick={() => { onLogout(); setOpen(false); }}>
                  <LogoutIcon sx={{ mr: 1, fontSize: 20 }} />
                  <ListItemText primary="Sair" />
                </ListItemButton>
              </ListItem>
            </List>
          </Box>
        </Drawer>
      </Toolbar>
    </AppBar>
  );
}

export default Menu;
